import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

import AlertContainer from "../../alertContents/AlertContainer";
import MatchMenuElement from "../../../../assets/components/Match/MenuElment";
import { menuItems } from "./menuItems";

const container = {
  hidden: { opacity: 1, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2,
    },
  },
};

const itemContainer = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export default function MatchDashboardMenu() {
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  const [alertContent, setAlertContent] = useState(null);
  const { quizId } = useSelector(({ quiz }) => quiz);
  const handleStartQuiz = () => {
    navigate(`/preMatch/${quizId}`);
  };

  const handleClickMenuItem = (item, index, disabled) => {
    if (disabled) {
      return;
    }
    const linkItems = [
      "شروع چالش",
      "ماموریت ها",
      "پروفایل",
      "جدول پیشتازان",
      "تاریخچه پله‌ها",
      "پله بارون",
    ];
    if (linkItems.includes(item)) {
      if (item === "شروع چالش") {
        handleStartQuiz();
      } else {
        navigate(menuItems[index].link);
      }
    } else {
      setAlertContent(menuItems[index].content);
      setShowAlert(true);
    }
  };

  return (
    <>
      <motion.div
        className="m-0 p-0 row justify-content-between"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        {menuItems.map((item, index) => {
          return (
            <motion.div
              variants={itemContainer}
              key={index}
              className={`${
                item.width === "half"
                  ? index % 2 === 0
                    ? "col-6 pr-2 pl-0"
                    : "col-6 pl-2 pr-0"
                  : "col-12 p-0"
              } m-0`}
            >
              <MatchMenuElement
                elementInfo={item}
                fullWidth={item.width === "full"}
                disable={item.disable}
                showNew={item.showNew}
                handleClick={() =>
                  handleClickMenuItem(item.text, index, item.disable)
                }
              />
            </motion.div>
          );
        })}
      </motion.div>
      <AlertContainer
        show={showAlert}
        content={alertContent}
        handleClose={() => setShowAlert(false)}
      />
    </>
  );
}
